<template>
	<div class="w-100">
		<div
		v-for="(f, i) in flds.content"
		:key="i"
		class="w-100 p-3 overflow-hidden shadow border-15 mb-3 d-flex flex-wrap"
		:class = "(f.status==1) ? ' bg-white ' : ' bg-brand-light '"
		>
		
		<div v-if="f.status != 3 && f.status != 0" class="col-lg-2 col-md-2 col-sm-12 col-xs-12 float-right text-center p-0" @click="rtr(f.id)">
				<userImg
					v-if="f.status != 3"
					:src="f.img"
					imgSize="110"
					:class ="(windowWidth > 770) ? '' : ' m-auto'"
					:data-toggle="(f.status==1) ? '' : 'tooltip'"
					data-placement="right"
					:star="f.grade"
					:level="f.level"
				/>
			</div>
			
			<div v-if="f.status != 3 && f.status != 0" class="col-lg-5 col-md-5 col-sm-12 col-xs-12 float-right">
				<div class="">
					<p
						v-if="f.status != 3"
						class="bMikhak"
						:class="(windowWidth<776) ? 'text-center mt-3' : ''"
						style="font-size:20px;"
						@click="rtr(f.id)"
					>
						{{f.fullname}}
						<br>
						<span class="text-success" style="font-size: 15px;" v-if="f.status==1 && ['all'].includes($route.params.id)">
							(فعال)
						</span>
						<span class="text-success" style="font-size: 15px;" v-if="f.status==2 && ['all'].includes($route.params.id)">
							(پروفایل کامل/ غیرفعال/ ادمین)
						</span>
						<span class="text-success" style="font-size: 15px;" v-if="f.status==3 && ['all'].includes($route.params.id)">
							(بلاک شده‌ها)
						</span>
						<span class="text-success" style="font-size: 15px;" v-if="f.status==5 && ['all'].includes($route.params.id)">
							(حذف شده‌ها)
						</span>
						<span class="text-success" style="font-size: 15px;" v-if="f.status==6 && ['all'].includes($route.params.id)">
							(درخواست تغییر یا ارتقا)
						</span>
						<span class="text-success" style="font-size: 15px;" v-if="f.status==7 && ['all'].includes($route.params.id)">
							(پروفایل ناقص با احراز هویت)
						</span>
						<span class="text-success" style="font-size: 15px;" v-if="f.status==10 && ['all'].includes($route.params.id)">
							(پروفایل کامل/غیرفعال/در انتظار بررسی مدارک)
						</span>
						<span class="text-success" style="font-size: 15px;" v-if="f.status==11 && ['all'].includes($route.params.id)">
							(نقص مدارک ارزیابی)
						</span>
						<span class="text-success" style="font-size: 15px;" v-if="f.status==12 && ['all'].includes($route.params.id)">
							(رد شده‌ها)
						</span>
						<span class="text-success" style="font-size: 15px;" v-if="f.status==13 && ['all'].includes($route.params.id)">
							(در انتظار فعال سازی(ارزیاب))
						</span>
						<p style="font-size: 15px;" v-if="f.admins_fullname">
							<b class="text-danger">
								بررسی کنندگان:
							</b>	
							{{f.admins_fullname}}
						</p>
					</p>
					<div
						v-if="f.status != 3"
						dir="ltr"
						class="bMikhak mt-3"
						:class="(windowWidth<776) ? 'text-center' : ''"
						:title="f.province+'، '+f.county"
						:alt="f.province+'، '+f.county"
					>
						{{f.province}}
						<span v-show="f.county!='' && f.county!=null">
							،
						</span>
						{{f.county}}
						&nbsp
						<img
							:src="require('../../../assets/img/Location.svg')"
						/>
					</div>
					<div v-if="f.status != 3" class="text-truncate mt-3" :class="(windowWidth<776) ? 'text-center' : ''" >
						<span  v-for="(c, j) in flds.content[i].cats" :key="j">
							{{c.name}}
							<span v-if="j != (flds.content[i].cats.length-1)">
								،
							</span>
						</span>
						<br class="m-0" v-if="!chechRole()">
						<span v-if="!chechRole()">
							<span class='bMikhak text-success '>
								تاریخ ثبت نام:
							</span>
							{{ f.dat }}
							<span class='bMikhak text-success '>
								زمان ثبت نام: 
							</span>
							  {{ f.tim }}
						</span>
						<br class="m-0" v-if="!chechRole() && ['1', '2', '7', '12', 'all'].includes($route.params.id) ">
						<span 
						class="pointer bold" 
						style="color: #AA000C;" 
						v-if="!chechRole() && ['1', '2', '7', '12', 'all'].includes($route.params.id) &&  ['0'].includes($localStorage.get('user').username.access_level)"
						@click="del_teacher2(f.id)"
						>
							حذف استاد
						</span>
					</div>
				</div>
			</div>
			<div v-if="f.status != 3 && f.status != 0" class="col-lg-5 col-md-5 col-sm-12 col-xs-12 float-right">
				<img
					class="pointer"
					style="position: absolute; left: 0;"
					:src="require('../../../assets/img/best_off.svg')"
					width="40"
					title="استاد برتر نیست"
					alt="استاد برتر نیست"
					v-if="!chechRole() && (f.teacher_best_status==null || f.teacher_best_status==0) && ['1'].includes($route.params.id)"
					@click="set_best(f.id, f.fullname, f.teacher_best_status)"
				/>
				<img
					class="pointer"
					style="position: absolute; left: 0;"
					:src="require('../../../assets/img/best_on.svg')"
					width="40"
					title="استاد برتر"
					alt="استاد برتر"
					v-if="!chechRole() && !(f.teacher_best_status==null || f.teacher_best_status==0) && ['1'].includes($route.params.id)"
					@click="set_best(f.id, f.fullname, f.teacher_best_status)"
				/>
				<img
					class=""
					style="position: absolute; left: 0;"
					:src="require('../../../assets/img/selected.svg')"
					width="40"
					title="استاد برتر"
					alt="استاد برتر"
					v-if="chechRole() && !(f.teacher_best_status==null || f.teacher_best_status==0) "
				/>
				<img
					class=""
					style="position: absolute; left: 40;"
					:src="require('../../../assets/img/calender_off.svg')"
					width="40"
					title="روزی ثبت نشده است"
					alt="روزی ثبت نشده است"
					v-if="f.classes==0"
				/>
				<img
					class=""
					style="position: absolute; left: 40;"
					:src="require('../../../assets/img/calender_on.svg')"
					width="40"
					title="روزی ثبت شده است"
					alt="روزی ثبت شده است"
					v-else
				/>
				<div
					v-if="f.status != 3"
					class="text-success text-left"
					:class="(windowWidth<776) ? 'text-center mt-3' : ''"
					:title="f.grade"
				>
					<!-- {{f.grade}} -->
					&nbsp
					<!-- <img
						:src="require('../../../assets/img/star.svg')"
					/> -->
				</div>
				<!-- ********************************************************** -->


				

				<router-link 
					:to="'/teachers/'+f.id" 
					v-if="chechRole() && f.status != 3">
					<btn :class="(windowWidth < 767) ? 'w-100' : '' " :textClass="(windowWidth < 767) ? 'w-100' : '' " type="success" class="float-left mt-4" text="مشاهده" />
				</router-link>
				<!-- ********************************************************** -->
				<router-link 
					:to="'/signupTeacher/'+f.id" 
					v-if="!chechRole() && ((f.status != 3 && f.status != 10 && f.status != 13) || ['all'].includes($route.params.id)) && !['1','4','5','6','8'].includes($localStorage.get('user').username.access_level)">
					<btn :class="(windowWidth < 767) ? 'w-100' : '' " :textClass="(windowWidth < 767) ? 'w-100' : '' " type="success" class="float-left mt-4" text="ویرایش" />
				</router-link>
				<!-- ********************************************************** -->
				<router-link :to="'/class/list/'+f.id"
				 v-if="!chechRole() && ['1', '2', '6', '5', 'all'].includes($route.params.id) && !['1','4','5','6','7','8'].includes($localStorage.get('user').username.access_level)">
					<btn 
					:class="(windowWidth < 767) ? 'w-100' : '' " :textClass="(windowWidth < 767) ? 'w-100' : '' " type="outline-success" class="ml-1 float-left mt-4"
					 text="کلاس ها" />
				</router-link>
				<!-- ********************************************************** -->
				<router-link :to="'/authentication/'+f.id" 
				v-if="!chechRole() && ['2', '10', '5','6'].includes($route.params.id) && !['1','4','5','6','8'].includes($localStorage.get('user').username.access_level)">
					<btn
						:class="(windowWidth < 767) ? 'w-100' : '' " :textClass="(windowWidth < 767) ? 'w-100' : '' "
						type="success"
						class="ml-1 float-left mt-4"
						text="بررسی مدارک"
					/>
				</router-link>
				<router-link :to="'/passauthentication/'+f.id" 
				v-if="!chechRole() && ['13'].includes($route.params.id) && ['0','8'].includes($localStorage.get('user').username.access_level)">
					<btn
						:class="(windowWidth < 767) ? 'w-100' : '' " :textClass="(windowWidth < 767) ? 'w-100' : '' "
						type="success"
						class="ml-1 float-left mt-4"
						text="بررسی مدارک"
					/>
				</router-link>
			</div>
			<div v-if="f.status == 3 || f.status == 0 " class="col-lg-8 col-md-8 col-sm-12 col-xs-12 d-flex align-items-center">
				<p>{{ f.phone }} تاریخ ثبت نام: {{ f.dat }} 
					<span  class="text-success" style="font-size: 15px;" v-if="f.status==0 && ['all'].includes($route.params.id)">
						(ثبت نام بدون احراز هویت)
					</span>

				</p>
			</div>
			<div v-if="f.status == 3" class="col-lg-6 col-md-6 col-sm-12 col-xs-12  d-flex align-items-center">
				<p class="text-danger">{{ f.fullname ? 'به دلیل رد اطلاعات احراز هویت توسط کاربر' : 'به دلیل وارد کردن اطلاعات بیش از حد مجاز 3 بار' }}</p>
			</div>
			<div v-if="f.status == 3" class="col-lg-2 col-md-2 col-sm-12 col-xs-12  d-flex align-items-center">
				<span class="pointer bold btn btn-danger"  v-if="f.status == 3" @click="del_teacher(f.phone)" :class="(windowWidth < 767) ? 'w-100' : '' " :textClass="(windowWidth < 767) ? 'w-100' : '' " type="danger" text="حذف" >حذف</span>
			</div>
			
			
			<div v-if="f.status == 0" class="col-lg-4 col-md-4 col-sm-12 col-xs-12  d-flex align-items-center justify-content-end">
				<router-link 
					:to="'/signupTeacherFromAdmin/'+f.id" 
					>
					<btn :class="(windowWidth < 767) ? 'w-100' : '' " :textClass="(windowWidth < 767) ? 'w-100' : '' " type="success" text="ویرایش" />
				</router-link>
			</div>
			<div v-if="['0', '1'].includes($localStorage.get('user').username.access_level)" class="d-flex align-items-end">
				<!-- @inputTxtFunc = "(e)=>{val.crm_id = e;}" -->
				<selectInput
					:class_select="f.id"
					:id_tag="'select'+f.id"
					:class="(windowWidth < 767) ? '' : '' " :textClass="(windowWidth < 767) ? '' : ''" type="success" class="float-left mt-1"
					@inputTxtFunc = "(e)=>{alt(f.crm_id, e, f.id); f.crm_id = e}"
					:placeholder ="f.crm_id ? crms.data.content.filter((item, key) => item.id == f.crm_id)[0].fullname : null "
					label="انتخاب کارشناس CRM"
					:flds="crms.data.content.filter((item, key) => item.access_level == 3)"
				/>
				<!-- {{ crms.data.content.filter((item, key) => item.id == f.crm_id)[0].fullname }} -->
				<!-- <span v-if="val.crm_id.length > 0" @click="assigntocrm(val.crm_id, f.id)" :class="(windowWidth < 767) ? 'cbtn w-100 mr-2' : 'cbtn mr-2' " :textClass="(windowWidth < 767) ? 'cbtn w-100 mr-2' : 'cbtn mr-2' " type="success">ثبت</span> -->
			</div>
		</div>
		<div class="w-100" style="display: flex; align-items: center; justify-content: center;">
		<pageNavigation :page="flds.curPage" :pages="flds.totalPages" @setPage="setPage"  />
	</div>
	</div>
</template>

	<script>
		import btn from  "../../../UI/button/btn.vue";
		import selectInput from  "../../../UI/input/selectInput.vue";
		import userImg from  "../../../UI/userImg/userImg.vue";
		import pageNavigation from  "../../../UI/pageNavigation/pageNavigation.vue";
		export default {
			name: 'teachers_part1',
			data(){
				return {
					baseurl: window.baseurl,
					val:{
						crm_id: [],
					},
					crms: {ok: null, data: []},
				}
			},
			components: {
				btn,
				pageNavigation,
				userImg,
				selectInput
			},
			props: {
				flds: {
					type: Object,
					default: null,
				},
			},
			mounted(){
				window.$('[data-toggle="tooltip"]').tooltip();
				if(this.$localStorage.get('user')==null){
					this.$localStorage.set('urlPath', window.location.pathname);
					this.$router.push('/login');
				}else{
					this.crmslist();
				}
			},
			methods:{
				// *********************************************************************
				crmslist( THIS = this){
					if(this.$localStorage.get("user").username.role == 3) {
						window.$.post(this.baseurl+"admin/list", {
							role: this.$localStorage.get("user").username.role, 
							token: this.$localStorage.get("user") 
						}, function(D){
							
						
							if(D.data) {
								THIS.crms = {ok: true, data: D.data};
								
							}
						
						}, "json");
					}
				},
				//******************************************************** */
				alt(o, n, adminid, THIS = this){
					if(o != n) {
						this.$swal.fire({
							icon: "",
							title: 'آیا پشتیبان تغییر کند ؟!',
							showCancelButton: true,
							showCloseButton: true,
							confirmButtonText:"بلی",
							confirmButtonColor:"#126457",
							cancelButtonText:"بستن",
						}).then((result) => {
							if(result.value){

								window.$.post(this.baseurl+"crm/assign", {
									teacher_id: adminid ? adminid : null, 
									crm_id: n ? n : null, 
									role: this.$localStorage.get("user").username.role, 
									token: this.$localStorage.get("user") 
								}, function(D){
									if(D.data) {
										window.location.reload();
									}
								
								}, "json");
							}
						})
					}
					console.log(o,n);
				},
				//******************************************************** */
				set_best(id=0, fullname="", status=0, THIS = this){
					let title = `<p class="text-center">
						<img src=`+require('../../../assets/img/best_on.svg')+` class="w-50" /><br/>
						<p style="font-size: 30px;">
							آیا مدرس 
							<b class="text-success">`+fullname+`</b>،
							استاد برتر است؟
						</p></p>`;
					if(status == 1){
						title = `<p class="text-center">
						<img src=`+require('../../../assets/img/best_off.svg')+` class="w-50" /><br/>
						<p style="font-size: 30px;">
							آیا مدرس 
							<b class="text-danger">`+fullname+`</b>،
							از حالت استاد برتر خارج شود؟
						</p></p>`;
					}
					this.$swal.fire({
						icon: "",
						html: title,
						showCancelButton: true,
						showCloseButton: true,
						confirmButtonText:"بلی",
						confirmButtonColor:"#126457",
						cancelButtonText:"بستن",
					}).then((result) => {
						if(result.value){
							window.$.post(window.baseurl + 'accountTeacher/best', {token: this.$localStorage.get('user'), id: id, status: status}, function (D) {
								THIS.$emit('setPage', 1);
							}, "json");
						}
					})
				},
				del_teacher2(id, THIS = this) {
					this.$swal.fire({
						icon: '',
						title: "آیا حذف شود؟",
						showCancelButton: true,
						showCloseButton: true,
						confirmButtonText:"بلی",
						confirmButtonColor:"#aa000c",
						cancelButtonText:"بستن",
					}).then((result) => {
						if(result.value){
							window.$.post(window.baseurl + 'accountTeacher/step_teacher', {
								fild: 'status' ,val: 5, id: id,
								admin: this.$localStorage.get('user')
							}, function () {
								THIS.$emit('setPage', 1);
							}, "json");
						}
					})
				},
				del_teacher(phone, THIS = this) {
					this.$swal.fire({
						icon: '',
						title: "آیا حذف شود؟",
						showCancelButton: true,
						showCloseButton: true,
						confirmButtonText:"بلی",
						confirmButtonColor:"#aa000c",
						cancelButtonText:"بستن",
					}).then((result) => {
						if(result.value){
							window.$.post(window.baseurl + 'ithub/delteacher', {phone: phone}, function () {
								THIS.$emit('setPage', 1);
							}, "json");
						}
					})
				},	
				//********************************************************** */
				rtr(id){
					if(this.chechRole()){
						this.$router.push('/teachers/'+id)
					}
				},
				// *********************************************************************
				chechRole(){
					let user = this.$localStorage.get('user');
					if(user == null){
						return true;
					}else if(user.username.role != 3){
						return true;
					}else{
						return false;
					}
				},
				// *********************************************************************
				search(e){
					this.$emit('filterPage', e.target.value);
				},
				// *********************************************************************
				setPage(page){
					this.$emit('setPage', page);
				},
				assigntocrm(crm_id, adminid ,THIS = this){
					console.log('adminid', adminid);
					console.log('crm_id', crm_id);
					console.log('this.baseurl', this.baseurl);
					document.body.scrollTop = 0;
				
					window.$.post(this.baseurl+"crm/assign", {
						teacher_id: adminid ? adminid : null, 
						crm_id: crm_id ? crm_id : null, 
						role: this.$localStorage.get("user").username.role, 
						token: this.$localStorage.get("user") 
					}, function(D){
						if(D.data) {
							window.location.reload();
						}
					
					}, "json");
				}
			}
		}
	</script>
<style>
.cbtn {
    background: #31ab31;
    padding: 3px 10px;
    border-radius: 7px;
    color: #fff;
    margin-bottom: 3px;
	cursor: pointer;
}
</style>
